export default (t) => {
    return  [
        {
            question: t('Data Collection'),
            answer: (<> {t('For the purpose of the report, our sample size is assumed to be representative of the market, based on the wide accessibility of our free tools to a large range of users. As our sample size grows, we expect our report to more accurately reflect real world results. These applications are marketed in OPSWAT’s own channels. Users sampled may not be representative of the general population. For example, this report may contain a different distribution of Windows operating systems and device types compared to what exists in the real world. The purpose of OPSWAT’s Market Share Reports is to inspire discussion, not to make any claims on which anti-malware vendors are the best or to compare these vendors in terms of quality or performance')} </>)
        },
        {
            question: t('Disclaimer of Warranty'),
            answer: (<> {t('OPSWAT Inc. makes no representation or warranties, either express or implied by or with respect to anything in this document, and shall not be liable for any implied warranties of merchantability or fitness for a particular purpose or for any indirect special or consequential damages')} </>)
        },
        {
            question: t('Trademark and Copyright Notice'),
            answer: (<> {t('OPSWAT®, MetaAccess®, MetaDefender®, and the OPSWAT logo are registered trademarks of OPSWAT, Inc. All other trademarks, trade names and images mentioned and/or used herein belong to their respective owners. No patent liability is assumed with respect to the use of the information contained herein. While every precaution has been taken in the preparation of this publication, OPSWAT Inc. assumes no responsibility for errors or omissions. This publication and features described herein are subject to change without notice. ©2021 OPSWAT, Inc. All rights reserved')} </>)
        }
    ];
};







